import type { FC, PropsWithChildren } from 'react';
import { memo } from 'react';
import { extendAnalyticsData, useSportUrlParams } from '@mwl/core-lib';
import { routes } from '@/constants';
import { Button } from '../Button/Button';
import type { SportLinkProps } from './SportLink.types';
const BaseSportLink: FC<PropsWithChildren<SportLinkProps>> = ({
  children,
  sport,
  className,
  analytics
}) => {
  const {
    createSportItemLink,
    sportId
  } = useSportUrlParams({
    routes
  });
  if (sportId === String(sport.id)) {
    return <span className={className}>{children}</span>;
  }
  const href = createSportItemLink(String(sport.id));
  return <Button as="link" href={href} className={className} variant="text" analytics={analytics ? extendAnalyticsData(analytics, {
    href
  }) : undefined} data-sentry-element="Button" data-sentry-component="BaseSportLink" data-sentry-source-file="SportLink.tsx">
      {children}
    </Button>;
};
export const SportLink = memo(BaseSportLink);
SportLink.displayName = 'SportLink';